import React, { createContext, useContext } from "react";
import useSocketConnection from "../hooks/useSocketConnection";

const SocketContext = createContext(null);

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const { socket, serverResponse } = 
  // useSocketConnection("ws://192.168.20.47:5001")
      useSocketConnection()
  //  useSocketConnection(process.env.REACT_APP_BACKEND_URL);

  return (
    <SocketContext.Provider value={{ socket, serverResponse }}>
      {children}
    </SocketContext.Provider>
  );
};
